import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {SupplyAcquisitionTypeEnum} from '../../../enums/supply-acquisition-type.enum';
import {EnumUtils} from '../../../utils/enum.utils';

@Component({
    selector: 'app-supply-acquisition-type-input',
    templateUrl: './supply-acquisition-type-input.component.html',
    styleUrls: ['./supply-acquisition-type-input.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => SupplyAcquisitionTypeInputComponent),
        multi: true
    }
    ]
})
export class SupplyAcquisitionTypeInputComponent implements OnInit, ControlValueAccessor {


    public model: SupplyAcquisitionTypeEnum;


    public supplyAcquisitionTypeEnum = SupplyAcquisitionTypeEnum;
    public lastUsedMPSValue: SupplyAcquisitionTypeEnum;

    @Input() public isMpsDisabled = false;

    // public tabsChoices = ['MPS - Stückzahl basiert', 'MPS - Seitenzahl basiert', 'MPS - Seitenpreis basiert'];
    // public tabsValues = [
    //     SupplyAcquisitionTypeEnum.MPS_BASED_ON_PAGE_COUNT_o,
    //     SupplyAcquisitionTypeEnum.MPS_BASED_ON_UNIT_COUNT_o,
    //     SupplyAcquisitionTypeEnum.MPS_BASED_ON_PAGE_PRICE_o,
    // ];

    public tabsChoices = ['MPS - Stückzahlbasiert', 'MPS - Seitenpreisbasiert'];
    public tabsValues = [
        SupplyAcquisitionTypeEnum.MPS_BASED_ON_UNIT_COUNT,
        SupplyAcquisitionTypeEnum.MPS_BASED_ON_PAGE_PRICE
    ];

    propagateChangeFn: any = () => {
    }
    onTouchedFn: any = () => {
    }


    constructor() {
    }

    public ngOnInit() {
    }

    public registerOnChange(fn: any): void {
        this.propagateChangeFn = fn;
    }

    public registerOnTouched(fn: any): void {
        this.onTouchedFn = fn;
    }

    // gets value from outside and write it to component model value
    public  writeValue(value: string): void {

        if (value !== null && value !== undefined) {
            this.model = SupplyAcquisitionTypeEnum[value];
        } else {
            this.model = SupplyAcquisitionTypeEnum.NONE;
        }

        if (this.model !== SupplyAcquisitionTypeEnum.NONE && this.model !== SupplyAcquisitionTypeEnum.PURCHASE) {
            this.lastUsedMPSValue = this.model;
        }
    }


    public onPrintSmartShoppingBtnClicked() {

        if (this.isMpsDisabled) {
            return;
        }

        if (this.lastUsedMPSValue === undefined || this.lastUsedMPSValue === null) {
            this.lastUsedMPSValue = SupplyAcquisitionTypeEnum.MPS_BASED_ON_PAGE_PRICE;
        }

        this.model = this.lastUsedMPSValue;

        this.propagateChangeFn(EnumUtils.getKeyByValue(SupplyAcquisitionTypeEnum, this.model));
        this.onTouchedFn();
    }

    onGeneralShoppingBtnClicked() {
        this.model = SupplyAcquisitionTypeEnum.PURCHASE;
        this.propagateChangeFn(EnumUtils.getKeyByValue(SupplyAcquisitionTypeEnum, this.model));
        this.onTouchedFn();
    }
}
